import React from 'react';
import PropTypes from 'prop-types';
import FormattedHTMLMessage from '../../../components/FormattedHTMLMessage';

function SetupWizardTitleHeader({classNameFormat, intlTextFormat, titleFormat, customTitleId}) {
  return (
    <div className={`step-${classNameFormat}-header`}>
      <p className={`step-${classNameFormat}-title title`}>
        <FormattedHTMLMessage id={customTitleId || `setupWizard.step.${titleFormat || intlTextFormat}.title`} />
      </p>
      <p className={`step-${classNameFormat}-body-text content-text`}>
        <FormattedHTMLMessage id={`setupWizard.step.${intlTextFormat}.bodyText`} />
      </p>
    </div>
  );
}

SetupWizardTitleHeader.propTypes = {
  classNameFormat: PropTypes.any.isRequired,
  intlTextFormat: PropTypes.any.isRequired,
  titleFormat: PropTypes.any,
  customTitleId: PropTypes.any,
};

SetupWizardTitleHeader.defaultProps = {
  titleFormat: '',
  customTitleId: null,
};

export default SetupWizardTitleHeader;
